import { Route } from "react-router-dom";
import Login from "../Pages/Login";
import LoginLayout from "../themes/Login/LoginLayout";

const LoginRoutes = () => {
    return (
        <Route path="/login/*" element={<LoginLayout />}>
            <Route index path="" element={<Login />} />  
        </Route>

    );
};

export default LoginRoutes;